export default __webpack_public_path__ + "static/media/radio-pc-color-blue-selected.18ebc574.svg";